import { Directive, ElementRef, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthorizationService } from 'src/app/features-common/services/authorization.service';

@Directive({
  selector: '[hideIfUnauthorized]'
})
export class HideIfUnauthorizedDirective implements OnInit {
  //    @Input('hideIfUnauthorized') permission: string; // Required permission passed in

  private permission: string;
  @Input()
  set hideIfUnauthorized(claimName: string) {
    // console.log(`current permission for : ${claimName}`);
    this.permission = claimName;
  }

  constructor(private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    private authorizationService: AuthorizationService) { }

  ngOnInit() {

    if (this.authorizationService.hasPermission(this.permission)) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainerRef.clear();
    }
  }
}
